import React, { useEffect, useMemo, useState } from "react";
import KapalService from "../../services/kapal/KapalService";

const DisposisiKapal = ({ idDisposisi }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [ketDisposisi, setKetDisposisi] = useState('')

    useEffect(() => {
        const getDisposisi = async () => {
            const response = await kapalService.getDisposisiById(idDisposisi)
            // console.log(response)
            setKetDisposisi(response.data.ketDisposisi)
        }
        getDisposisi()
    }, [kapalService, idDisposisi])

    return (
        <>
            {ketDisposisi}
        </>
    )
}

export default DisposisiKapal